import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import { connect } from 'react-redux';
import { Paginate } from 'components/elements/Paginate';
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { CardList } from 'components/elements/CardList';
import CampaignsStyle from "components/admin/Campaigns.module.scss";
import { Helmet } from 'react-helmet';
import classnames from 'classnames';
import MaterialTable from 'material-table';
import { tableIcons } from './TableIcons';
import { Utils } from 'utils/Utils';
import { Modal } from "components/modal/Modal";
import { PartnerAdminActions } from 'state/actions/user/PartnerAdminActions';

/**
 * Junta `CardList` com `Paginate` em um novo componente. :)
 * 
 * @param {{
 *   history: any,
 *   location: any,
 *   match: any,
 *   staticContext: any,
 * }} props
 */
const CampaignsIssuesContainer = ({
  history,
  location,
  match,
  staticContext,
  person,
  token,
  isAdmin
}) => {
  // State
  // --------------------------------------------------------------------
  const columns =  [
    { title: 'PersonId', field: 'personId', editable: 'never', hiddenByColumnsButton: true },
    { title: 'Problema', field: 'issue', editable: 'never', hiddenByColumnsButton: true,
    render: (rowData) => {
      return (
        <IssueComponent issue={rowData.issue} />
      );
    } },
    { title: 'CampaignId', field: 'campaignId', editable: 'never', hiddenByColumnsButton: true },
    { title: 'Data de criação', field: 'dateCreated', editable: 'never', hiddenByColumnsButton: true,  
      render: (rowData) => {
        return Utils.tempConvertDate(rowData.dateCreated)
      }
    }
  ];

  const IssueComponent = ({ issue }) => {
    const [modal, setModal] = useState(false);
    if (!issue) return null;
  
    return (
      <>
        <Modal
          visible={modal}
          onCloseModal={() => setModal(!modal)}>
          <div>           
            <div>
              <p>Problema reportado:</p>
              <textarea className={"m-0 col-12"}>{issue}</textarea>
            </div>
          </div>
        </Modal>
        <button //className={"btn btn-sm btn-light-pink"}
          onClick={() => setModal(!modal)}>
          Ver Problema reportado
        </button>
      </>
    );
  };

  const [data, setData] = useState([]);
  const [headers, setHeaders] = useState(columns);
  const [failure, setFailure] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(9);
  const [totalItems, setTotalItems] = useState(0);

  // Aqui usamos 0, preencha no request de inicialização depois

  // Métodos
  // --------------------------------------------------------------------

  /**
   * Solicita dados da página.
   * 
   * @param {number} page 
   */
  const fetchDataFromApi = async (page) => {
    const endpoint = GlamboxEndpoints.Campaign.getIssues.url;
    let url = `${process.env.REACT_APP_GB_API_ROOT}${endpoint}?page=${page - 1}&pageSize=${perPage}`;

    fetch(url, {
      method: "GET",
      headers: new Headers({
        'Authorization': token
      })
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        setData(json.result.issues);
        setPage(page);
        setFailure(false);
        setTotalItems(json.result.totalOfItems);
      })
      .catch(err => {
        setData([]);
        setFailure(true);
        setTotalItems(0);
      });
  }

  // Lifecycle
  // --------------------------------------------------------------------

  // Funciona como `componentDidMount`, executando apenas na inicialização
  // Para que funcione assim, o segundo parametro de useEffect precisa estar vazio
  useEffect(() => {
    if (typeof person !== "undefined") {
      isAdmin(
        person.person.username,
        (response)=>{
          const isAdmin = response.result;
          if(!isAdmin){
            history.push("/");
          }else{
            fetchDataFromApi(page);

          }
        });
    }
  }, [person]);

  if (!person || !token) return null;
  return (
    <div className={"p-2 p-lg-5"}>
      <Helmet>
        <title>Admin Campanha : Problemas com campanhas</title>
      </Helmet>
      <h1>Problemas com campanhas</h1>

      <div className={CampaignsStyle["container"]}>
        <MaterialTable
          title=""
          columns={headers}
          data={data}
          options={{
            filtering: false,
            exportButton: true,
            exportAllData: true,
          }}
          icons={tableIcons}
        />

      </div>
    </div>
  );
};

CampaignsIssuesContainer.defaultProps = {
  history: null,
  location: null,
  match: null,
  staticContext: null,
  token: null,
  person: null
};

CampaignsIssuesContainer.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
  staticContext: PropTypes.func,
  token: PropTypes.string,
  person: PropTypes.object
};

const mapStateToProps = (state) => ({
  token: state.token.data.Authorization,
  person: state.person.data
});

const mapDispatchToProps = (dispatch) => ({
  isAdmin:(email, callback)=>{
    dispatch(PartnerAdminActions.isAdmin(email, callback));
  }
});

const StatefulCampaigns = connect(
  mapStateToProps,
  mapDispatchToProps
)(CampaignsIssuesContainer);

export const CampaignsIssues = withRouter(StatefulCampaigns);
